















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import PicPreview from "@/components/pic-preview.vue";
import { getZhuanjia } from "@/request/idr";
import TimeTab from "./time-tab.vue";
import Jiqi from "./jiqi.vue";
import Zhuanjia from "./zhuanjia.vue";
import { GetMian, SaveMian } from "@/request/zhuanbingshujuku";
@Component({
  components: {
    PicPreview,
    TimeTab,
    Jiqi,
    Zhuanjia,
  },
})
export default class IdrMian extends Vue {
  @Prop()
  private message: any;
  private current: any = {
    面象照片: {},
    面色唇色参数: [],
  };
  private ifShowPicPreview: boolean = false;
  private picUrl: any = "";
  private faceIndex: any = 0;
  private cPart: any = "机器";
  private changeCurrentItem(item, index) {
    this.$set(this, "current", item);
    this.faceIndex = index;
    this.cPart = "机器";
  }

  @Watch("message", { immediate: true })
  private messageChange(msg) {
    console.log("message数据");
    console.log(msg);
    this.partChange("机器");
  }
  private get ifCompose() {
    return this.$store.state.ifCompose;
  }
  /**
   * @description 打开预览图
   */
  private showPreview(url) {
    this.picUrl = url;
    this.ifShowPicPreview = true;
  }
  /**
   * @description 获取数据
   */
  private partChange(part) {
    this.cPart = part;
    const params: any = {
      params: {
        // patient_id: "c0908ebe6fa5708f0a009674f263f114",
        patient_id: this.message["patient_id"],
        zhenci_id: this.message["zhenci_id"],
      },
    };
    GetMian(this, params).then((data: any) => {
      this.current = data;
    });
  }
  /**
   * @description 保存数据
   */
  private save() {
    return new Promise((resolve, reject) => {
      const params = {
        face_id: this.current.face_id,
        face_dic: this.current,
      };
      SaveMian(this, params).then((data: any) => {
        this.partChange(this.cPart);
        // this.cContent = data;
        this.$message.success("保存成功");
        this.$store.commit("updateIfCompose", false);
        // this.$emit("refresh");
        resolve();
      });
    });
  }
}
